import { createContext } from "react"
import { fullConsent, UserConsent } from "cookiesConsent/domain/consent"

export const defaultConsent = fullConsent

const ConsentContext = createContext<UserConsent>(defaultConsent)

export default ConsentContext
